import { Link } from "react-router-dom";
import { features } from "@/mocks/homeData";

export default function FeaturesSection() {
  return (
    <section className="w-full bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            为什么选择我们
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto text-sm md:text-base">
            致力于为用户提供最可靠的爱情岛网址导航服务
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group p-6 rounded-2xl bg-background-100 hover:bg-background-100/80 transition-all duration-200"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 mb-4 group-hover:bg-secondary-200 transition-colors">
                <i className={`${feature.icon} text-xl`}></i>
              </span>
              <h3 className="font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            了解更多关于我们
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}